// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__oVzOs","dropdown":"navbar_dropdown__3Rgx7"};